import { FC, useMemo } from "react";

import {
  FilterByIdListAppliedFilterView,
  FilterByIdListItem,
} from "@/domain/view/components/datatable/datatable-filters/filter-by-id-list-applied-filter-view.tsx";

import { useSmartFocusAreaList } from "../../hooks/api/use-smart-focus-area-list";
import { FocusAreaViewOptional } from "../focus-area-view-optional";

import { DatatableFocusAreaDisplayView } from "./datatable-focus-area-display-view";

export interface DatatableFocusAreaAppliedFilterViewProps {
  workspaceId: string;
  columnId: string;
  displayValue: string;
}

export const DatatableFocusAreaAppliedFilterView: FC<DatatableFocusAreaAppliedFilterViewProps> = ({
  workspaceId,
  columnId,
  displayValue,
}) => {
  // Use smart hook that switches between public/private data sources
  const { focusAreaList, findFocusAreaById } = useSmartFocusAreaList({
    workspaceId: workspaceId,
  });

  const itemList = useMemo(() => {
    return focusAreaList.map((focusArea) => ({
      id: focusArea.id,
      name: focusArea.name,
    }));
  }, [focusAreaList]);

  const renderItem = (item: FilterByIdListItem | null, view: "icon" | "text" | "icon-text") => {
    const showText = view === "text" || view === "icon-text";

    return <FocusAreaViewOptional key={item?.id} focusArea={findFocusAreaById(item?.id ?? "")} logoOnly={!showText} />;
  };

  const renderDisplayView = () => {
    return <DatatableFocusAreaDisplayView displayValue={displayValue} />;
  };

  return (
    <FilterByIdListAppliedFilterView
      columnId={columnId}
      itemList={itemList}
      renderItem={renderItem}
      renderDisplayView={renderDisplayView}
    />
  );
};
